export const CLICK_BELOW = "Click below to view upcoming events!";

export const NO_SET = -1;
export const MIDDLE_SCHOOL_INDEX = 0;
export const HIGH_SCHOOL_INDEX = 1;
export const GENERIC_HEADING = "Upcoming Events";
export const MIDDLE_SCHOOL_HEADING = "Middle School";
export const HIGH_SCHOOL_HEADING = "High School";
